import React, { useState } from 'react';
import logo from './sarf-logo-invert.png';
import './App.css';
import { BG, CenteredContainers, CenteredLow, CenteredText, CorrectButton, Counter, Disclaimer, IntroScene, MotionContainer, Page, TextBox, TopContainer } from './components/usefulContainers';
import { useScroll, useTransform, motion } from 'framer-motion';
import { StylizedCounter } from './components/counter';
import { Quotes } from './components/testemonials';
import { Qanda } from './components/questions';



function App() {
  const foundDate = 1771870855563;
  const day = 86400000;
  console.log(Date.now());
  const getCount = () => {
    var date = Date.now();
    var diff = date - foundDate;
    var days = diff/day;
    var counting = 10;
    for (let i=0; i < days; i++){
      if (Math.random() < 0.5){
        counting++
      }
    } 
    return counting
  };
  const [count, setCount] = useState(getCount());
  const { scrollYProgress } = useScroll();

  const fadeOut = useTransform(
    scrollYProgress,
    [0, .03, 1],
    ["blur(0px)", "blur(10px)", "blur(10px)"],
  );
  const fadeIn = useTransform(
    scrollYProgress,
    [0, .02, 1],
    ["blur(10px)", "blur(0px)", "blur(0px)"]
  );
  const opacityOut = useTransform(
    scrollYProgress,
    [0, .03, 1],
    [1, 0, 0]
  )
  const opacityIn = useTransform(
    scrollYProgress,
    [0, .02, 1],
    [0, 1, 1]
  )
  const opacityInCount = useTransform(
    scrollYProgress,
    [0, .07, .12, .3, .35, 1],
    [0, 0, 1, 1, 1, 1]
  )
  const opacityInText = useTransform(
    scrollYProgress,
    [0, .6, .7, 1],
    [0, 0, 1, 1]
  )
  const bgFade = useTransform(
    scrollYProgress,
    [0, .12, 1],
    [1, .5, .5]
  )
  const backgroundColor = useTransform(
    scrollYProgress,
    [0, .12, .13, 1],
    ["#ffffff00", "#ffffff00", "#ffffffff", "#ffffffff"]
  )
  const color = useTransform(
    scrollYProgress,
    [0, .12, .13, 1],
    ["rgba(255, 255, 255, 1)", "rgba(255, 255, 255, 1)", "#000000ff", "#000000ff"]
  )
  const opacityImg = useTransform(
    scrollYProgress,
    [0, .12, .13, 1],
    [0, 0, 1, 1]
  )
  const width = useTransform(
    scrollYProgress,
    [0, .12, .13, 1],
    ["0vw", "0vw", "", ""]
  )
  const fontSize = useTransform(
    scrollYProgress,
    [0, .11, .12, 1],
    ["4vh", "4vh", "3vh", "3vh"]
  )
  return (
    <Page>
      <BG
        style={{
          filter: fadeOut, opacity: bgFade
        }} />
      <IntroScene style={{ height: "50vh" }}>
        <CenteredContainers>
          <MotionContainer
            style={{
              filter: fadeOut, opacity: opacityOut
            }}>
            ▼ Welcome to... ▼
          </MotionContainer>
        </CenteredContainers>
      </IntroScene>
      <TopContainer
        style={{ filter: fadeIn, opacity: opacityIn, 
        backgroundColor, color, fontSize: fontSize }}>
        <br />
        <motion.img src={logo} style={{ height: "10vh", opacity: opacityImg, width: width }} />
        <div style={{ display: "flex", width: "100%", justifyContent: "center", textAlign: "center" }}>
          The Sebastian is Always Right Foundation
        </div>
      </TopContainer>
      <CenteredLow>
        <Counter
          style={{ opacity: opacityInCount }}>
          <h2> Times Sebastian <br />has been Correct*</h2>
          <StylizedCounter targetValue={count} />
          <h2>
            and counting!
          </h2>
          <br />
          <br />
          <br />
         
          <CorrectButton onClick={() => setCount(count + 1)}> Sebastian was Right!</CorrectButton>
          <br/>
          *If you are here because Sebastian was right <br />please report it and help the foundation!
        </Counter>
        <h1 style={{width: "100%", zIndex:"0", 
          textAlign: "center", paddingTop: "27vh", 
          fontSize: "4vh"}}>
          Hear what our donors are saying!
        </h1>
        <br/>
        <br/>
        <Quotes />
        <div style={{ zIndex: "0",
          paddingBottom: "50vh", display: "flex", flexDirection:"column", 
          justifyContent: "center", alignItems: "center", paddingTop:"10vh"
        }}>
          <div style={{fontSize:"3vh", paddingBottom:"4vh"}}>
            Donate to the Foundation!
          </div>
          <a style={{textDecoration: "none", width: "100%",
            display: "flex", flexDirection: "column", justifyContent: "center",
            alignItems: "center"
          }} href="https://cash.app/$CashPulgo" target="_blank" rel="noopener noreferrer">
               <CorrectButton>
                Donate now and stop being a moron today!
               </CorrectButton>
              
            </a>
        </div>
        <Qanda/>
        <CenteredText
          style={{ opacity: opacityInText }}>
          <Disclaimer style={{ fontSize: "1.5vh" }}>
            <h2 style={{ fontSize: "3vh" }}>
              The Foundation's History
            </h2>
            <h3 style={{ fontSize: "2vh", paddingLeft: "3vw", paddingRight: "3vw" }}>
              The foundation was officially started in 2026 when, its founder and CEO, Sebastian won an impossible bet against a doubter.
              This event prompted him to create S.A.R.F. so that no person would have to be incorrect around him again. Our mission is to
              spread truth so that people don't have to suffer the shame and hummiliation of being incorrect in front of Sebastian.
            </h3> <br />
            © 2026 Sebastian. All Rights Reserved.
          </Disclaimer>
        </CenteredText>

      </CenteredLow>
    </Page>
  );
}

export default App;
